import { render, staticRenderFns } from "./star-display.vue?vue&type=template&id=cec78d22&"
import script from "./star-display.vue?vue&type=script&lang=js&"
export * from "./star-display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cec78d22')) {
      api.createRecord('cec78d22', component.options)
    } else {
      api.reload('cec78d22', component.options)
    }
    module.hot.accept("./star-display.vue?vue&type=template&id=cec78d22&", function () {
      api.rerender('cec78d22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dXnwG13M0xhJ/JS/comp/star-display.vue"
export default component.exports